// src/OnlineBookingContainer.js
import { useState, useEffect } from "preact/hooks";
import Details from "../Details";
import "../App2.css";
import ProcessingComponent from "./ProcessingComponent";

// Reads the location from the URL and hands it to the Details screen, which
// draws the whole page: the dark stage with the title and the step indicator,
// the white panel, and the Next button under it. The old header and stepper
// that lived here are gone; the mockup puts them on the stage.
function OnlineBookingContainer() {
  const [locationId, setLocationId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const locId = queryParams.get("locationId");
    if (locId) setLocationId(locId);
    setIsLoading(false);
  }, []);

  return (
    <>
      {isLoading && (
        <ProcessingComponent
          height={"30vh"}
          msg={"Loading, please stand by..."}
        />
      )}
      {locationId && (
        <div id="app" className="ob-root">
          <Details
            locationId={locationId}
            onIsNextEnabled={() => {}}
            isSubmitEnabled={() => {}}
          />
        </div>
      )}
    </>
  );
}

export default OnlineBookingContainer;
